import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * CATIA-sınıfı Shaft/Groove (revolve) Definition penceresi (FikoDialogCore içeriği).
 * First/Second Angle · Dönme Ekseni (V/U/X/Y/Z) · Reverse · canlı önizleme.
 */
@Component({
  selector: 'fikoyt-shaft-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Birinci Limit</div>
      <div class="sd-row"><label>İlk Açı</label><div class="sd-num"><input type="number" min="-360" max="360" step="5" [ngModel]="el.aci ?? 360" (ngModelChange)="setNum('aci',$event)"/><span>°</span></div></div>
    </div>
    <div class="sd-grup">
      <label class="sd-chk"><input type="checkbox" [ngModel]="!!el.limit2Aktif" (ngModelChange)="set('limit2Aktif',$event)"/> İkinci Limit (ters yön açı)</label>
      @if(el.limit2Aktif){
        <div class="sd-row"><label>İkinci Açı</label><div class="sd-num"><input type="number" min="-360" max="360" step="5" [ngModel]="el.aci2 ?? 0" (ngModelChange)="setNum('aci2',$event)"/><span>°</span></div></div>
      }
    </div>
    <div class="sd-grup">
      <div class="sd-bas">Dönme Ekseni</div>
      <div class="sd-row"><label>Eksen</label>
        <select [ngModel]="el.shaftEksen || 'v'" (ngModelChange)="set('shaftEksen',$event)">
          <option value="v">Sketch Dikey (V)</option>
          <option value="u">Sketch Yatay (U)</option>
          <option value="x">X Ekseni</option>
          <option value="y">Y Ekseni</option>
          <option value="z">Z Ekseni</option>
        </select>
      </div>
      <button class="sd-btn" [class.aktif]="el.tersYon" (click)="set('tersYon',!el.tersYon)">⇅ Yön Çevir (Reverse)</button>
    </div>
    <div class="sd-altbar">
      <button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button>
      <button class="sd-btn sd-sil" (click)="sil()">🗑 Sil</button>
    </div>
  </div>
  `,
  styles: [`
    .sd{padding:6px 10px 10px;color:#dbe4f0;font:500 12px/1.4 system-ui,sans-serif;min-width:225px;}
    .sd-grup{border-top:1px solid rgba(120,160,255,.16);padding:6px 0 3px;}
    .sd-grup:first-child{border-top:none;}
    .sd-bas{font-size:10px;font-weight:800;color:#7db0ff;text-transform:uppercase;letter-spacing:.5px;margin:0 0 5px;}
    .sd-row{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:3px 0;}
    .sd-row label{font-size:11.5px;color:#aab8cc;}
    .sd-row select{flex:1;max-width:150px;background:rgba(10,20,35,.85);color:#fff;border:1px solid rgba(0,200,255,.35);border-radius:5px;padding:3px 5px;font-size:11px;cursor:pointer;outline:none;}
    .sd-num{display:flex;align-items:center;gap:4px;}
    .sd-num input{width:62px;background:rgba(0,0,0,.4);color:#fff;font-weight:700;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;outline:none;}
    .sd-num input:focus{border-bottom-color:#00d0ff;background:rgba(0,60,80,.5);}
    .sd-num span{color:#00d0ff;font-size:10px;}
    .sd-chk{display:flex;align-items:center;gap:7px;font-size:11.5px;color:#cbd5e1;cursor:pointer;padding:3px 0;}
    .sd-chk input{accent-color:#00d0ff;cursor:pointer;width:14px;height:14px;}
    .sd-btn{width:100%;margin-top:4px;background:rgba(20,40,60,.7);color:#cfe6f5;border:1px solid rgba(0,200,255,.3);border-radius:6px;padding:5px;font-size:11.5px;font-weight:600;cursor:pointer;transition:all .15s;}
    .sd-btn:hover{background:rgba(0,150,200,.4);border-color:#00d0ff;}
    .sd-btn.aktif{background:rgba(0,200,255,.3);border-color:#00d0ff;color:#fff;}
    .sd-altbar{display:flex;gap:6px;margin-top:8px;}
    .sd-altbar .sd-btn{margin-top:0;}
    .sd-ok{background:rgba(20,120,80,.55);border-color:rgba(52,211,153,.5);color:#a7f3d0;}
    .sd-ok:hover{background:rgba(20,160,100,.7);}
    .sd-sil{flex:0 0 70px;background:rgba(120,30,30,.5);border-color:rgba(239,68,68,.5);color:#fca5a5;}
    .sd-sil:hover{background:rgba(160,40,40,.7);}
  `]
})
export class FikoShaftDialog {
  @Input() element: any;   // IOzellik (shaft/groove)
  @Input() yonetici: any;  // FikoModellemeYonetici
  @Input() pencere: any;   // FikoDialogCore
  get el() { return this.element; }
  get yon() { return this.yonetici; }

  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }

  set(anahtar: string, deger: any): void { this.yonetici?.padGuncelle(this.element, anahtar, deger); this.CD.markForCheck(); }
  setNum(anahtar: string, deger: any): void { const v = +deger; if (!isNaN(v)) this.yonetici?.padGuncelle(this.element, anahtar, v); this.CD.markForCheck(); }
  private kapat(): void { (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
